/**
 * @generated SignedSource<<f15b48b8a5d29b98eab1ab58f90ebd4a>>
 * @relayHash f0fadf070bf739b267bcae904d9e8931
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 57302b2cd221bf042e07b853be9b0493a8e4eb757da0ef7a4ca7e9f395e454cb

import { ConcreteRequest } from 'relay-runtime';
export type accountAuditLogsPageQuery$variables = {
  account: string;
};
export type accountAuditLogsPageQuery$data = {
  readonly account: {
    readonly id: string;
  };
};
export type accountAuditLogsPageQuery = {
  response: accountAuditLogsPageQuery$data;
  variables: accountAuditLogsPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "account"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "account"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "accountAuditLogsPageQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": "account",
          "args": (v1/*: any*/),
          "concreteType": null,
          "kind": "LinkedField",
          "name": "accountBySlug",
          "plural": false,
          "selections": [
            (v2/*: any*/)
          ],
          "storageKey": null
        },
        "action": "THROW"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "accountAuditLogsPageQuery",
    "selections": [
      {
        "alias": "account",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "accountBySlug",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f0fadf070bf739b267bcae904d9e8931",
    "id": "57302b2cd221bf042e07b853be9b0493a8e4eb757da0ef7a4ca7e9f395e454cb",
    "metadata": {},
    "name": "accountAuditLogsPageQuery",
    "operationKind": "query",
    "text": "query accountAuditLogsPageQuery(\n  $account: String!\n) {\n  account: accountBySlug(slug: $account) {\n    __typename\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "836b101ab9687762b31e8b1cb394eb05";

export default node;
